import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarqComponentComponent } from './barq-component/barq-component.component';
import { WayyakComponentComponent } from './wayyak-component/wayyak-component.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { QrComponent } from './qr/qr.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { NgxPrintModule } from 'ngx-print';
import { LottieAnimationViewModule } from 'ng-lottie';
import { TranslateModule } from '@ngx-translate/core';
import { FilterComponent } from './filter/filter.component';
import { PaymentLinkComponent, ViewPaymentLink } from './payment-link/payment-link.component';
import { ScrollbarThemeModule } from '../directives/scrollbar-theme.directive';
import { RedeemptionComponent, ViewRedeem } from './redeemption/redeemption.component';



@NgModule({
  entryComponents: [
    FilterComponent,
    ViewRedeem,
    ViewPaymentLink
  ],
  declarations: [
    BarqComponentComponent,
    WayyakComponentComponent,
    QrComponent,
    FilterComponent,
    PaymentLinkComponent,
    RedeemptionComponent,
    ViewRedeem,
    ViewPaymentLink
  ],
  exports: [
    BarqComponentComponent,
    WayyakComponentComponent,
    QrComponent,
    FilterComponent,
    PaymentLinkComponent,
    RedeemptionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    NgxQRCodeModule,
    NgxPrintModule,
    LottieAnimationViewModule,
    ScrollbarThemeModule,
    TranslateModule
  ]
})
export class ComponentModulesModule { }


